export const FETCH_LICENSES_LIST = 'FETCH_LICENSES_LIST';
export const FETCH_SINGLE_LICENSE = 'FETCH_SINGLE_LICENSE';
export const FETCH_LICENSE_FAIL = 'FETCH_LICENSE_FAIL';
